import { storeAction } from "../actionTypes"
const initialState = {
    storeData:[],
    loader: false,
    autoAccept: false,

}

export default function store(state = initialState, {type, payload}) {
    switch(type) {
   
      case storeAction.STORE_DETAILS_INITIATE: {
        return {
          ...state, storeData: [],
          loader: true,
        }
      }
      case storeAction.STORE_DETAILS_SUCCESS: {
        return {
          ...state, 
          storeData:payload,
          autoAccept:payload?.data?.isAutoAccept,
          loader: false,
        }
      }
      case storeAction.STORE_DETAILS_FAILURE: {
        return {
          ...state, storeData: [],
          loader: false,
        }
      }
  
      default: 
      return state
  }
  }